module.exports = __webpack_public_path__ + "img/page2-bg-phone.760360e7.png";